@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss"; // for the tabular-grid-cell-layout mixin

$nameInlineSize: 40px;
$moreBtnInlineSize: 64px;

:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  display: contents;
}
// Header
.header {
  grid-template:
    "name type" max-content
    "object object" max-content;
  grid-template-columns: 1fr 1fr;
}
.name__field {
  grid-area: name;
}
.name__label {
  inline-size: $nameInlineSize;
}
.type__field {
  grid-area: type;
}
.more__btn {
  grid-area: more;
  inline-size: $moreBtnInlineSize;
}
.object-selector__field {
  grid-area: object;
}

// Main
.main {
  overflow: auto;
}

ch-tabular-grid.tabular-grid--empty::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}
ch-tabular-grid-rowset-empty {
  position: relative; // makes this the bounder element for the loader
}

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid-row",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    2,
    3,
    4
  )
);

// WA: remove this when Mercury removes margin from p elements
.matching-attributes {
  margin: 0;
}
